









import { defineComponent } from "@vue/composition-api";
import { CellGroup, Cell } from "vant";

export default defineComponent({
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell
  },
  data: () => ({}),
  created() {},
  methods: {
    naviTo(path: string) {
      this.$toMiniAppWeb("/web/manager/v" + path);
    }
  }
});
